
export class ActionRecommendationsViewModel {
  RuleId: number;
  CustomerId: number;
  Customer: string;
  JobSiteId: number;
  JobSite: string;
  ModelId: number;
  Model: string;
  RuleName: string;
  RuleDesc: string;
  RuleDetails: string;
  Components: string;
  CreatedUser: string;
  Date: Date;
  RuleAdded: boolean;
  RuleSelected: boolean;
}

export class ActionRecommendationRuleDetailsViewModel {
  RuleComponentId: number;
  RuleId: number;
  ComponentTypeId: number;
  ComponentType: string;
  Side: number;
  SideName: string;
  Position: number;
  ActionTypeId: number;
  ActionType: string;
  NewPosition: number;
  Description: string;
  LifeExtendedHours: number;
  LabourCost: number;
  PartCost: number;
  MiscCost: number;
  CreatedUser: string;
  CreatedDate: Date;
  ModifiedUser: number;
  ModifiedDate: Date;
}

export class ActionRecommendationsSearchFiltersViewModel {
  CustomerId: number;
  JobSiteId: number;
  ModelId: number;
}

export class ActionRecommendationAttachRulesViewModel {
  RuleId: number;
  RuleComponentId: number;
  RuleName: string;
  RuleDesc: string;
  ComponentType: string;
  Side: string;
  Position: string;
  ActionType: string;
  Description: string;
  CreatedUser: string;
  Date: Date;
  RuleSelected: boolean;
  RuleAttached: boolean;
}

export class ActionRecommendationAttachRuleViewModel {
  RuleId: number;
  RuleDetailId: number;
  InspectionId: number;
  StartSMU: number;
  QuoteId: number;
  ActionDate: Date;
}
